import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@context/AuthContext';
import ProtectedRoute from '@components/ProtectedRoute';
import LoginPage from '@pages/LoginPage';
import PortalPage from '@pages/PortalPage';
import HomePageWrapper from '@pages/HomePageWrapper';

function App() {
  return (
    <AuthProvider>
      {/* No basename - app runs at root level (/, /portal, /login) */}
      {/* Assets load from /static/ via Vite base config */}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePageWrapper />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/portal"
            element={
              <ProtectedRoute>
                <PortalPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
